import React from 'react'
import error from '../../assets/404.png'
import './error.css';
import { useNavigate } from 'react-router-dom';
function Error() {
    const navigate = useNavigate();
    return (
        <>
        <div className='box-error'>
        <img src={error} alt='404_image' />
        <h3>
        Oops! page not found
        </h3>
        <span>
        Ut consequat ac tortor eu vehicula. Aenean accumsan purus eros. Maecenas sagittis tortor at metus mollis
        </span>
        <button onClick={()=>{navigate('/')}}>
            Back to Home
        </button>
        </div>    
        
        </>
    );
}

export default Error;